module.exports = __webpack_public_path__ + "media/introduction_5.78f9ed8e.mp4";